import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import { parseDateWithoutTimezoneShift } from "../Generics/Helps"
import { BaseModel } from "../Generics/BaseModel"


export class NoticeEntity extends BaseModel {
  id: number
  name: string
  description: string
  iconUrl: string
  status: EEnableStatusType
  startDate: Date
  endDate: Date

  constructor(data: Partial<NoticeEntity> = {}) {
    super()

    this.id = data.id ?? -1

    this.name = data.name ?? ""

    this.description = data.description ?? ""

    this.iconUrl = data.iconUrl ?? ""

    this.status = data.status ?? EEnableStatusType.Active

    this.startDate = parseDateWithoutTimezoneShift(data.startDate)

    this.endDate = parseDateWithoutTimezoneShift(data.endDate)
  }

  isVisibleAt(date: Date) {
    const base = new Date(date)
    base.setHours(0, 0, 0, 0)

    const start = new Date(this.startDate)
    start.setHours(0, 0, 0, 0)

    const end = new Date(this.endDate)
    end.setHours(0, 0, 0, 0)

    return this.status === EEnableStatusType.Active && base >= start && base <= end
  }
}
